<template>
  <div class="basic-info">
    <div class="info-content">
      <div class="head-img">
        <span class="head-img-title">头像：</span>
        <el-upload class="avatar-uploader" action :auto-upload='false' :show-file-list="false"
          :on-change="onUploadChange" accept='.jpg, .png, .gif, .tif, .psd, .bmp'>
          <img v-if="imageUrl" :src="imageUrl" alt='检查网络' class="avatar">
          <img v-if="!imageUrl" src="@/assets/img/profile/headImg.png" class="avatar">
          <button>更换头像</button>
        </el-upload>
      </div>

      <el-form ref="form" :model="userForm" label-width="80px" size="mini">

        <el-form-item v-if="userForm.tel" label="账号:">
          <el-input disabled v-model.trim="userForm.tel"></el-input>
        </el-form-item>

        <el-form-item class="content-name" label="昵称:">
          <div class="content-star">
            *
          </div>
          <el-input class="nameInput" v-model.trim="userForm.userName"></el-input>
        </el-form-item>

        <el-form-item class="content-name" label="姓名:">
          <el-input class="nameInput" v-model.trim="userForm.petName"></el-input>
        </el-form-item>

        <el-form-item class="content-name" label="地区:">
          <v-distpicker :wrapper='"content-name-wrapper"' :province='userForm.location.province.value'
            :city='userForm.location.city.value' :area='userForm.location.area.value' @province="onChangeProvince"
            @city="onChangeCity" @area='onChangeArea' @selected='onChangeSelected'>
          </v-distpicker>
        </el-form-item>

        <el-form-item class="content-name" label="详细地址:">
          <el-input class="nameInput" v-model.trim="userForm.address"></el-input>
        </el-form-item>

        <el-form-item label="性别:">
          <el-radio v-model.trim="userForm.gender" label="男">男</el-radio>
          <el-radio v-model.trim="userForm.gender" label="女">女</el-radio>
        </el-form-item>

        <el-form-item label=" 出生日期:">
          <el-date-picker :picker-options="pickerOptions" value-format="yyyy-MM-dd" :editable='true'
            v-model="userForm.birthday" type="date" placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
      </el-form>

    </div>
    <button @click="onSubmit" class="save-btn">
      <img src="@/assets/img/profile/btn.png" alt="">
      <span>保存</span>
    </button>

  </div>

</template>

<script>
// import VDistpicker from "v-distpicker";
// import VDistpicker from "../../../../../../../node_modules/v-distpicker/src/Distpicker";
import VDistpicker from "./components/Distpicker";

import { getUserMsg, resetUserMsg } from "@/network/loginRequest/api";
import utils from "@/util/index";
export default {
  name: "Basicinfo",
  components: {
    VDistpicker,
  },
  data() {
    return {
      imageUrl: "",
      //日期--------------------------------------------
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now() - 8.64e6; //如果没有后面的-8.64e6就是不可以选择今天的
        },
      },
      userForm: {
        //电话--------------------------------------------
        tel: "",
        //昵称
        userName: "",
        //姓名
        petName: "",
        //性别
        gender: "",
        //生日
        birthday: "",
        //区域
        location: { province: "", city: "", area: "" },
        //用户地址
        address: "",
      },
      //用户信息
      user: this.$store.state.user,
      //修改信息
      fd: new FormData(),
    };
  },

  created() {
    this.init();
  },

  methods: {
    //初始化数据
    init() {
      this.updataUserInfo(this.user);
    },

    //更新用户信息
    updataUserInfo(info) {
      //头像--------------------------------------------
      this.imageUrl = info.userIconPath;
      //账号--------------------------------------------
      this.$set(this.userForm, "tel", info.telephone);
      //昵称--------------------------------------------
      this.$set(this.userForm, "userName", info.userName);
      //姓名--------------------------------------------
      this.$set(this.userForm, "petName", info.petName);
      //区域--------------------------------------------
      this.$set(
        this.userForm,
        "location",
        info.location != -1
          ? JSON.parse(info.location)
          : { province: "", city: "", area: "" }
      );

      //地址--------------------------------------------
      this.$set(
        this.userForm,
        "address",
        info.address != -1 ? info.address : ""
      );

      //性别--------------------------------------------
      this.$set(this.userForm, "gender", info.gender);
      //生日--------------------------------------------

      this.$set(
        this.userForm,
        "birthday",
        info.birthday != -1 ? (info.birthday ? info.birthday : "") : ""
      );
    },

    handleAvatarSuccess(res, file) {
      this.imageUrl = URL.createObjectURL(file.raw);
    },

    //修改头像
    onUploadChange(file) {
      const isLt100K = file.raw.size / 1024 < 2048;
      if (!isLt100K) {
        utils.tips("warning", "上传头像图片大小不能超过 2M!");
        return false;
      }

      this.fd.set("icon", file.raw);
      this.imageUrl = URL.createObjectURL(file.raw);
      return isLt100K;
    },

    //保存按钮--------------------------------------------
    onSubmit() {
      if (!this.userForm.userName) {
        utils.tips("warning", "请务必填写昵称!");
      } else {
        //用户id
        this.fd.set("id", this.$store.state.user.userId);
        //用户昵称
        this.fd.set("userName", this.userForm.userName);
        //用户姓名
        this.fd.set("petName", this.userForm.petName);
        //区域
        this.fd.set("location", JSON.stringify(this.userForm.location));
        //地址
        this.fd.set("address", this.userForm.address);
        //性别
        this.fd.set("gender", this.userForm.gender == "男" ? true : false);
        //生日
        if (this.userForm.birthday) {
          this.fd.set("birthDay", "" + this.userForm.birthday);
        } else {
          this.fd.set("birthDay", "");
        }
        resetUserMsg(this.fd).then((res) => {
          if (res.data.success) {
            utils.tips("success", "修改成功!");
            this.setUserVueX();
          } else {
            utils.tips("success", res.data.code);
          }
        });
      }
    },

    //给vuex的用户信息更新用户基本信息--------------------------------------------
    setUserVueX() {
      getUserMsg(this.$store.state.user.userId).then((res) => {
        if (res.data.success) {
          let obj = res.data.data;
          let user = this.$store.state.user;

          let newUser = {};
          for (const key in user) {
            if (user.hasOwnProperty(key)) {
              newUser[key] = user[key];
            }
          }

          //直接修改user会越过vuex--------------------------------------------
          for (const key in obj) {
            if (obj.hasOwnProperty(key)) {
              newUser[key] = obj[key];
            }
          }

          this.$store.commit("setUser", newUser);
        }
      });
    },

    //省
    onChangeProvince(data) {
      let obj = this.userForm.location;
      obj.province = data;
      this.$set(this.userForm, "location", obj);
    },

    //市
    onChangeCity(data) {
      let obj = this.userForm.location;
      obj.city = data;
      this.$set(this.userForm, "location", obj);
    },

    //区
    onChangeArea(data) {
      let obj = this.userForm.location;
      obj.area = data;
      this.$set(this.userForm, "location", obj);
    },

    //省市区
    onChangeSelected(data) {
      this.$set(this.userForm, "location", data);
    },
  },
};
</script>
  
<style lang="less" scoped>
.basic-info {
  width: 911px;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;

  .info-content {
    width: 911px;
    height: 472px;
    border: 1px solid #ccc;
    margin-bottom: 40px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: rgba(51, 51, 51, 1);

    .head-img {
      width: 472px;
      display: flex;
      margin-bottom: 22px;
      position: relative;

      .head-img-title {
        position: absolute;
        top: 0;
        left: 35px;
      }

      /deep/.el-upload {
        width: 232px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 14px;
        margin-left: 80px;

        img {
          width: 80px;
          height: 80px;
          border-radius: 50%;
        }

        button {
          cursor: pointer;
          width: 80px;
          height: 30px;
          border-radius: 3px;
          font-size: 12px;
          outline: none;
          border: none;
          background-color: #24ba58;
          color: #fff;
        }
      }
    }

    .el-form {
      width: 472px;
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);

      .content-name {
        width: 400px;

        .content-name-wrapper {
          height: 28px;
          display: flex;

          /deep/label {
            padding: 0 2px;

            select {
              font-size: 12px;
              color: #606266;
              height: 28px;
              padding: 0 15px;
              /*清除select的边框样式*/
              border: 1px solid #ccc;
              border-radius: 5px;
              /*清除select聚焦时候的边框颜色*/
              // outline: #24ba58;

              appearance: none;
              -moz-appearance: none;
              -webkit-appearance: none;
              // background: url("arrow.png") no-repeat scroll right center transparent;

              &:focus {
                /*清除select聚焦时候的边框颜色*/
                border: 1px solid #24ba58;
                outline: none;
              }
            }
          }
        }

        .content-star {
          position: absolute;
          top: 3px;
          left: -60px;
          color: red;
          font-size: 20px;
        }
      }
    }
  }

  .save-btn {
    cursor: pointer;
    width: 142px;
    height: 40px;
    background-color: #24ba58;
    color: #fff;
    border-radius: 3px;
    display: flex;
    justify-content: center;
    align-items: center;
    outline: none;
    border: none;

    span {
      margin-left: 9px;
    }
  }

  .save-btn:active {
    background-color: #24ba00;
  }

  option::-ms-expand {
    display: none;
  }

  option {
    -moz-appearance: none; /* Firefox */
    -webkit-appearance: none; /* Safari 和 Chrome */
    appearance: none;
  }

  /* --背景色字体颜色--*/
  option:hover {
    color: #fff;
    background-color: #1e90ff;
  }

  //修改UI样式

  /deep/.el-input__inner:focus {
    border-color: #24ba58;
  }

  /deep/.el-radio__input.is-checked + .el-radio__label {
    color: #24ba58;
  }
  /deep/.el-radio__input.is-checked .el-radio__inner {
    border-color: #24ba58;
    background: #fff;
    border-radius: 50%;
  }

  /deep/.el-radio__inner::after {
    width: 10px;
    height: 10px;
    background-color: #24ba58;
  }
}
</style>